/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_DocumentoMensaje as DocumentoMensaje,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ui as ui,
  rec_yQ as yQ,
} from "../../runtime/index.jsx";
export function ContenidoMensaje(e) {
  let t = (0, ReactCompiler.c)(17),
    { m: n, cliente: r } = e,
    i;
  t[0] === n.texto
    ? (i = t[1])
    : ((i = n.texto ? (
        <p className={`whitespace-pre-wrap break-words`} children={n.texto} />
      ) : null),
      (t[0] = n.texto),
      (t[1] = i));
  let a = i;
  if (n.tipo === `texto` || n.tipo === `otro` || n.tipo === `contacto`) {
    let e;
    return (
      t[2] !== n.tipo || t[3] !== a
        ? ((e = a ?? (
            <p
              className={`text-xs text-(--text)`}
              children={yQ(n.tipo) || `Mensaje`}
            />
          )),
          (t[2] = n.tipo),
          (t[3] = a),
          (t[4] = e))
        : (e = t[4]),
      e
    );
  }
  if (n.tipo === `ubicacion` && n.lat != null) {
    let e = `https://www.openstreetmap.org/?mlat=${n.lat}&mlon=${n.lng}#map=17/${n.lat}/${n.lng}`,
      r;
    t[5] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((r = (0, JSXRuntime.jsx)(ui, {
          className: `h-4 w-4`,
        })),
        (t[5] = r))
      : (r = t[5]);
    let i;
    t[6] === e
      ? (i = t[7])
      : ((i = (
          <a
            className={`inline-flex items-center gap-1 text-(--accent-texto) underline`}
            target={`_blank`}
            rel={`noreferrer`}
            href={e}
            children={[r, `Ver ubicación`]}
          />
        )),
        (t[6] = e),
        (t[7] = i));
    let o;
    return (
      t[8] !== a || t[9] !== i
        ? ((o = <JSXRuntime.Fragment children={[i, a]} />),
          (t[8] = a),
          (t[9] = i),
          (t[10] = o))
        : (o = t[10]),
      o
    );
  }
  let o;
  t[11] !== r || t[12] !== n
    ? ((o = n.tieneArchivo ? (
        <DocumentoMensaje m={n} cliente={r} />
      ) : (
        <p
          className={`text-xs text-(--text)`}
          children={[yQ(n.tipo), ` (sin archivo)`]}
        />
      )),
      (t[11] = r),
      (t[12] = n),
      (t[13] = o))
    : (o = t[13]);
  let s;
  return (
    t[14] !== a || t[15] !== o
      ? ((s = <JSXRuntime.Fragment children={[o, a]} />),
        (t[14] = a),
        (t[15] = o),
        (t[16] = s))
      : (s = t[16]),
    s
  );
}
